import { clearAllDrafts } from "@kovernow/flows/add_item";
import { safeLocalStorage, type AppServices } from "./services";

/**
 * What must not outlive a session: every `kn.draft.*` key, and the
 * uploads app's Firebase sign-in. Called on sign-out and on session loss.
 */
export function cleanUpAfterSession(services: Pick<AppServices, "uploads">): void {
  clearAllDrafts(safeLocalStorage());
  services.uploads.signOut().catch(() => {
    // In-memory Auth: nothing persists even if sign-out fails.
  });
}
